
import styled from 'styled-components';
import theme from "./../../styles/theme"

export const LogoWrapper = styled.div`
  padding: 35px;

  @media (max-width: 1400px) {
    padding: 15px;
  }
`;

export const Pillars = styled.div`
  position: relative;

`;

export const PillarsBackgroud = styled.div`
  @media (max-height: 1400px) {
    img{
      height: 720px;
    }
  }
`;



export const PillarsWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  height: 100%;
`;

export const PillarsBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;
`;

export const PillarsCards = styled.div`
  background-color: white;
  width: 270px;
  padding: 50px 25px 10px;
  position: relative;
  margin-right: 10px;
  margin-top: 100px;
  height: 460px;

  @media (max-width: 768px) {
    height: 250px;
  }
`;

export const TitlePillar = styled.div`
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  font-size: 22px;
  line-height: 27px;
  color: ${theme.colors.gray};
  padding-bottom: 10px;
  text-align: left;
  height: 60px;

`;

export const SubTitlePillar = styled.div`
  color: ${theme.colors.gray};
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-size: ${theme.fontSizes.small};
  font-weight: 500;
  line-height: 22px;
  text-align: left;

  @media (max-width:  ${theme.breakpoints.medium}){
    font-size: 12px;
  }

`;
export const PillarsImgs = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  top: -82px;
  left: 50%;
  transform: translateX(-50%);
  gap: 35px;
`;





export const TextImgs = styled.div`
  transition: all 0.2s ease-in-out;
  margin-bottom: -7px;

  img{
    transition: all 0.3s ease-in-out;
    width: 98px!important;
    padding-bottom: 30px;
  }
`;

export const IconsCards = styled.div`
  display: flex;

`;

